import Icon from './Icon';

const Pdf = (props) => {
  const { color } = props;
  return (
    <Icon {...props} viewBox="0 -2 18 18">
      <path
        d="M4.77205 10.1772L2.94175 12.2408C2.92402 12.2629 2.90466 12.2836 2.88385 12.3027C2.47069 12.6831 1.84963 12.273 2.03722 11.7437C2.04667 11.717 2.05812 11.6911 2.07148 11.6661L3.21094 9.14636"
        stroke={color}
        fill="none"
      />
      <path
        d="M4.08112 5.07351C3.9462 5.21411 3.74206 5.25684 3.5503 5.22222C2.89585 5.10404 2.19299 5.31893 1.68918 5.83055L1.41433 6.10985C1.15149 6.3767 1.01975 6.74523 1.05699 7.10946C1.09423 7.4737 1.29633 7.79331 1.60518 7.97636L6.4925 10.8729C6.80135 11.056 7.18275 11.0822 7.52699 10.9441C7.87124 10.8059 8.14021 10.5187 8.25657 10.1651L8.37847 9.79513C8.60038 9.12098 8.46684 8.41307 8.05997 7.89967C7.93619 7.74349 7.87671 7.53803 7.94149 7.34957L8.54007 5.60814C8.62101 5.37187 8.86215 5.22771 9.16528 5.23437L10.2949 5.2598C10.6441 5.26758 10.9057 5.0758 10.9443 4.78371C10.9828 4.49161 10.7898 4.16474 10.465 3.97223L5.93712 1.2887C5.6123 1.09618 5.22862 1.08123 4.98461 1.25157C4.74059 1.42191 4.691 1.73932 4.86149 2.03957L5.41322 3.01061C5.56113 3.27128 5.54469 3.54861 5.37059 3.72967L4.08112 5.07351Z"
        stroke={color}
        fill="none"
      />
    </Icon>
  );
};

Pdf.propTypes = Icon.proptypes;
Pdf.defaultProps = Icon.defaultProps;

export default Pdf;
